import React, { Component, useEffect, useRef } from "react";
import ReactDOM from "react-dom";
import styles from "./modalNotPayment.module.scss";
import { withAuth } from "../../../shared/containers/containerAuth";

class ModalNotPayment extends Component {
  render() {
    const { data } = this.props;

    if (!data.isNotPayment) {
      return null;
    }

    const node = document.getElementById("modalContainerId");
    if (!node) return null;

    return ReactDOM.createPortal(
      <div className={styles.modalNotPayment}>
        <div>ПОГАСИТЕ ЗАДОЛЖЕННОСТЬ!</div>
      </div>,
      node
    );
  }
}

export default withAuth(React.memo(ModalNotPayment));
